
import Transformer from './../transformer'

import moment from 'moment'
moment.locale('es-mx');

const fetchRejectedQuotationCollectionItem = function({ 
  id, is_active: isActive, reason, reject_date,
  rejection_days: rejectionDays, sinister,
})
{
  return {
    id,
    isActive,
    reason,
    rejectDate: moment(reject_date).format('DD/MM/YYYY'),
    rejectionDays,
    sinisterId: sinister ? sinister.sinister_id : null,
    are: sinister ? sinister.users_costs : null,
    assignmentDate: sinister ? moment(sinister.date_assignment).format('DD/MM/YYYY') : null,
    sinisterNumber: sinister ? sinister.sinister_number : null,
  }
}

export default class SinisterRoadTransformer extends Transformer {
  
  static fetchCollection(rejectedQuotation) {
    return rejectedQuotation.map(fetchRejectedQuotationCollectionItem)
  }
}


// WEBPACK FOOTER //
// ./src/transformers/sinister/rejectedQuotation.js